import {combineReducers} from 'redux'
import draftManagerSide from './manager_side'


export default combineReducers({
  draftManagerSide,
})
